<section class="login-mobile">

  <button class="login-mobile__close" type="button" aria-label="Close login dialog" (click)="closeModal()">
    <i class="fa fa-times"></i>
  </button>

  <div class="hero">
    <img src="/assets/images/login-boy.png" class="hero-img" alt="" aria-hidden="true">
  </div>

  <h2>Welcome Back 👋</h2>

  <p>
    Login to continue your learning journey with
    <span>askIITians</span>
  </p>

  <button class="email-btn" (click)="loginwithEmail()">

    <span class="icon">
      <img src="/assets/images/email-Icon-brand.svg">
    </span>

    {{unlockCtaText}}

    <i class="fa fa-angle-right"></i>

  </button>

  <!-- <div class="google-btn">

      <app-google-sso-login
      [clientId]="googleClientId"
      (onSigninSuccess)="onGoogleSigninSuccess($event)">
      </app-google-sso-login>

  </div> -->

  <div class="divider">
      <span></span>
  </div>

  <div class="features">

      <div>
          <span class="green"><i class="fa fa-shield"></i></span>
          <small>Secure<br>& Safe</small>
      </div>

      <div>
          <span class="blue"><i class="fa fa-video-camera"></i></span>
          <small>Live<br>Classes</small>
      </div>

      <div>
          <span class="purple"><i class="fa fa-bar-chart"></i></span>
          <small>Expert<br>Guidance</small>
      </div>

      <div>
          <span class="orange"><i class="fa fa-trophy"></i></span>
          <small>Better<br>Results</small>
      </div>

  </div>

</section>
